import { Person } from "@mui/icons-material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import MenuIcon from "@mui/icons-material/Menu";
import {
	Avatar,
	Button,
	IconButton,
	Menu,
	Paper,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Paths from "../Enums/Paths";
import { useAuth } from "../hooks/AuthContext";
import { ResponseContainer } from "../interfaces/RequestBase";
import { Logout } from "../requester/functions";
import NavBar from "./NavBar";

interface IProps {
	children?: any;
	isDark: boolean;
	setIsDark(value: boolean): void;
}

const Header = (props: IProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const path = useLocation().pathname;
	const navigate = useNavigate();

	const [auth] = useAuth();

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	return (
		<>
			<Paper
				className="flex z-50 justify-between items-center px-2 h-12"
				elevation={2}
			>
				<div className="flex gap-3 items-center">
					<IconButton
						onClick={() => {
							setIsOpen(!isOpen);
						}}
					>
						<MenuIcon />
					</IconButton>
					<Typography className="!m-0 !p-0" variant="h6">
						{Paths[path]}
					</Typography>
				</div>

				<div className="flex items-center">
					<span className="mr-2">{auth.name}</span>
					<IconButton sx={{ padding: "5px" }} onClick={handleClick}>
						<Avatar className="" src={auth.avatar} />
					</IconButton>
					<Menu
						open={anchorEl ? true : false}
						onClose={() => {
							setAnchorEl(null);
						}}
						anchorEl={anchorEl}
						variant={"menu"}
					>
						<div className="py-1 px-2 gap-1 flex flex-col">
							<Typography>{auth.name}</Typography>
							<div className="flex gap-2">
								<IconButton
									onClick={() => {
										localStorage.setItem(
											"theme",
											!props.isDark ? "dark" : "light"
										);
										props.setIsDark(!props.isDark);
									}}
									color="inherit"
								>
									{props.isDark ? <Brightness7Icon /> : <Brightness4Icon />}
								</IconButton>
								<IconButton
									onClick={() => {
										navigate(`/manager/${auth.id}`);
									}}
								>
									<Person />
								</IconButton>

								<Button
									color="error"
									variant="contained"
									onClick={() => {
										Logout((resp: ResponseContainer<null>) => {
											if (resp.status === "ok") {
												window.location.reload();
											}
										});
									}}
								>
									Выйти
								</Button>
							</div>
						</div>
					</Menu>
				</div>
			</Paper>
			<div className="h-full w-full flex">
				{isOpen ? (
					<div
						className="fixed top-0 z-30 w-full h-full bg-[rgba(0,0,0,0.5)]"
						onClick={() => {
							setIsOpen(false);
						}}
					></div>
				) : null}
				<NavBar isOpen={isOpen} />
				{props.children || null}
			</div>
		</>
	);
};

export default Header;

interface IProps {}
